import { render, staticRenderFns } from "./CreateTaskSeriesDialog.vue?vue&type=template&id=50929bc2&scoped=true"
import script from "./CreateTaskSeriesDialog.vue?vue&type=script&lang=js"
export * from "./CreateTaskSeriesDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateTaskSeriesDialog.vue?vue&type=style&index=0&id=50929bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50929bc2",
  null
  
)

export default component.exports